import Dialog from '@mui/material/Dialog'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { logout } from '../../../../routing/fetchingfunction/user/user.action'

const DeleteAccountSuccess = ({ open }) => {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const handleClose = () => {
    dispatch(logout())
    navigate('/')
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FDFDFD] !shadow-modal',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img
          src="/assets/icon/settings-change-success.svg"
          alt="Success"
          className="w-[124px] h-[124px]"
        />

        <h2 className="text-xl font-bold text-primary-100 mt-[16px]">
          Account Deleted Successfully
        </h2>

        <Link
          to="/"
          className="mt-[8px] text-sm font-medium text-primary-100 hover:underline hover:text-primary-100"
        >
          Visit Again
        </Link>

        <Link
          to="/"
          className="mt-[24px] w-full h-[44px] flex items-center justify-center shadow-button rounded-[8px] bg-primary-button hover:bg-primary-button-hover text-lg font-semibold text-white transition-colors duration-200 ease"
        >
          Continue
        </Link>
      </div>
    </Dialog>
  )
}

export default DeleteAccountSuccess
